import { Component, Event, EventEmitter, h, Host, Prop } from '@stencil/core'
import { copyToClipboard } from 'src/call/clipboard/clipboard'
import { classes } from 'src/utils/css'

import { CallMenuButton } from '../notes/ui'
import { CallStore } from '../state'
import { DetailPlayerSubNavTab, isSummaryTab } from './types'

@Component({
  tag: 'page-call-detail-player-sub-nav',
})
export class PlayerSubNav {
  @Prop() activeTab: DetailPlayerSubNavTab
  @Prop() copyTranscriptUrl: string

  @Event({ bubbles: false }) activeTabChanged: EventEmitter<DetailPlayerSubNavTab>
  render() {
    return (
      <Host class='px-2 bg-black'>
        <div class='flex z-10 flex-row spacing-x-3'>
          {CallStore.state.showSummaryTab && (
            <button
              class={`
                flex flex-row items-center spacing-x-7px
                uppercase text-base leading-none hover:text-link font-bold py-3 border-b-2
                ${classes(isSummaryTab(this.activeTab), 'text-link border-link', 'text-gray-90 border-gray-900')}
              `}
              onClick={() => this.activeTabChanged.emit('summary')}
            >
              <span>Summary</span>
            </button>
          )}
          <button
            class={`
              uppercase text-base leading-none hover:text-link font-bold py-3 border-b-2
              ${classes(this.activeTab === 'transcript', 'text-link border-link', 'text-gray-90 border-gray-900')}
            `}
            onClick={() => this.activeTabChanged.emit('transcript')}
          >
            Transcript
          </button>
          {CallStore.state.showAskFathomTab && (
            <button
              class={`
                uppercase text-base leading-none hover:text-link font-bold py-3 border-b-2
                ${classes(this.activeTab === 'ask_fathom', 'text-link border-link', 'text-gray-90 border-gray-900')}
              `}
              onClick={() => this.activeTabChanged.emit('ask_fathom')}
            >
              Ask Fathom
            </button>
          )}
          <div class='flex flex-row my-auto ml-auto spacing-x-1'>
            {this.activeTab === 'transcript' && this.copyTranscriptUrl && (
              <CallMenuButton onClick={async () => await copyToClipboard(this.copyTranscriptUrl, false)}>
                <span>Copy Transcript</span>
                <ui-icon icon='clipboard' class='pl-2 text-xl' />
              </CallMenuButton>
            )}
          </div>
        </div>
        <div class='z-0 -mt-2px h-2px bg-gray-900'>{/* Fake border bottom which goes under the above elements */}</div>
      </Host>
    )
  }
}
